import React, { useState } from 'react';
import './FiltroObras.css';

const FiltroObras = ({ filtro, onFiltroChange, darkMode }) => {
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFiltroChange({ [name]: value });
  };

  const toggleFiltros = () => {
    setMostrarFiltros(!mostrarFiltros);
  };

  const handleLimparFiltro = () => {
    onFiltroChange({
      termo: '',
      status: 'todos',
      ordenacao: 'recentes'
    });
  };

  return (
    <div className={`filtro-obras ${darkMode ? 'dark-mode' : ''}`}>
      <div className="filtro-header">
        <div className="filtro-busca">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Buscar obras..."
            name="termo"
            value={filtro.termo}
            onChange={handleChange}
          />
        </div>
        
        <button className="btn-toggle-filtros" onClick={toggleFiltros}>
          <i className="fas fa-filter"></i>
          Filtros
          <i className={`fas fa-chevron-${mostrarFiltros ? 'up' : 'down'}`}></i>
        </button>
      </div>
      
      {mostrarFiltros && (
        <div className="filtro-expandido">
          <div className="filtro-opcoes">
            <div className="filtro-grupo">
              <label>Status</label>
              <select 
                name="status" 
                value={filtro.status} 
                onChange={handleChange}
              >
                <option value="todos">Todos</option>
                <option value="em-andamento">Em Andamento</option>
                <option value="concluida">Concluída</option>
                <option value="pausada">Pausada</option>
                <option value="cancelada">Cancelada</option>
              </select>
            </div>
            
            <div className="filtro-grupo">
              <label>Ordenar por</label>
              <select 
                name="ordenacao" 
                value={filtro.ordenacao} 
                onChange={handleChange}
              >
                <option value="recentes">Mais Recentes</option>
                <option value="antigos">Mais Antigos</option>
                <option value="progresso">Maior Progresso</option>
                <option value="alfabetica">Nome (A-Z)</option>
              </select>
            </div>
          </div>
        </div>
      )}
      
      {(filtro.termo || filtro.status !== 'todos' || filtro.ordenacao !== 'recentes') && (
        <button className="btn-limpar-filtro" onClick={handleLimparFiltro}>
          <i className="fas fa-times"></i>
          Limpar Filtros
        </button>
      )}
    </div>
  );
};

export default FiltroObras; 